import GroupedPasswordInput from './GroupedPasswordInput';

export default GroupedPasswordInput;
